import React, { useEffect, useState } from "react";
import { Typography } from "@material-ui/core";
import { NavLink as RRNavLink } from "react-router-dom";
import { ABOUT_PATH } from "routes/paths";

const InternalLink = ({ title, link, activeLink }) => {
  const [navLinkClass, setNavLinkClass] = useState("site-pages");

  useEffect(() => {
    if (title === "PERSONAL") {
      if (
        activeLink.includes("business") ||
        activeLink === ABOUT_PATH ||
        activeLink.includes("bills-collect")
      ) {
        setNavLinkClass("site-pages");
        return;
      }
      setNavLinkClass("site-pages active");
      return;
    }

    if (
      window.location.pathname.split("/")[1] == "business" ||
      activeLink.includes("bills-collect")
    ) {
      setNavLinkClass("site-pages active");
    } else {
      setNavLinkClass(
        activeLink === link ? "site-pages active" : "site-pages "
      );
    }

    //
  }, [activeLink]);

  return (
    <RRNavLink
      exact
      to={link}
      style={{ textDecoration: "none" }}
      className={navLinkClass}
    >
      <Typography color="primary" variant="body1">
        <strong> {title}</strong>
      </Typography>
    </RRNavLink>
  );
};

const ExternalLink = ({ title, link }) => {
  return (
    <a
      href={link}
      target="_blank"
      style={{ textDecoration: "none" }}
      className="site-pages"
    >
      <Typography color="primary" variant="body1">
        <strong>{title}</strong>
      </Typography>
    </a>
  );
};

const Item = ({ type, pathname, ...other }) => {
  if (type === "Internal") {
    return <InternalLink activeLink={pathname} {...other} />;
  }
  return <ExternalLink {...other} />;
};

export default Item;
